<template>
  <b-dropdown ref="dropdown" :variant="variant" right no-caret menu-class="nav-dropdown" @show="emitOnShow" toggle-class="px-2">
    <template #button-content>
      <font-awesome-icon :icon="faEarthAsia" />
      <span v-if="showLanguageLabel" class="ml-1">{{ languageLabel }}</span>
    </template>
    <MenuLanguagesList @onChange="hideDropdown" />
    <slot></slot>
  </b-dropdown>
</template>

<script>
import { faEarthAsia } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'menu-language-nav-dropdown',
  props: {
    variant: {
      type: String,
    },
    onShow: Function,
    showLanguageLabel: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    MenuLanguagesList: () => import('./MenuLanguagesList.vue'),
  },
  data() {
    return {
      faEarthAsia,
    };
  },
  watch: {
    '$route'() {
      this.hideDropdown();
    },
  },
  computed: {
    languageLabel() {
      return _.get(this.$store.getters['app/getLanguageByCode'](this.$i18n.locale), 'name');
    },
  },
  methods: {
    emitOnShow() {
      this.$emit('onShow');
    },
    hideDropdown() {
      this.$refs.dropdown.hide(true);
    },
  },
};
</script>
